import { render, staticRenderFns } from "./StrutturePresidiListPage.vue?vue&type=template&id=7770001c"
import script from "./StrutturePresidiListPage.vue?vue&type=script&lang=js"
export * from "./StrutturePresidiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports